import { useMemo } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { PolicyDetails } from "shared";
import { apiRoutes } from "../../routing/routes";

export const usePolicy = (policyNumber: string) => {
  const { data: policy } = useMemo(
    () => useFetchApi<PolicyDetails>(apiRoutes.policy(policyNumber), 2),
    []
  );

  return policy;
};
